import { useEffect, useState } from 'react';

export const WORKSPACE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
export type WorkspacePageSize = (typeof WORKSPACE_PAGE_SIZE_OPTIONS)[number];

export const DEFAULT_WORKSPACE_PAGE_SIZE: WorkspacePageSize = 25;

/**
 * Page/pageSize state for server-driven tables.
 * Resets to page 1 when `resetKey` changes (filters, date range, cross-filter).
 */
export function useServerPagination(resetKey: string, defaultPageSize: WorkspacePageSize = DEFAULT_WORKSPACE_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState<WorkspacePageSize>(defaultPageSize);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const setPageSize = (size: WorkspacePageSize) => {
    setPageSizeState(size);
    setPage(1);
  };

  const offset = (page - 1) * pageSize;

  return {
    page,
    pageSize,
    setPage,
    setPageSize,
    offset,
  };
}

export function paginationRangeLabel(page: number, pageSize: number, total: number): string {
  if (total <= 0) return '0 of 0';
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return `${start}–${end} of ${total}`;
}

export function totalPages(total: number, pageSize: number): number {
  if (total <= 0 || pageSize <= 0) return 1;
  return Math.max(1, Math.ceil(total / pageSize));
}
